// external dependencies
import React, { memo } from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'

// constants
import { COLORS } from 'utils/styleHelpers'

// components
import BuyerzoneLight from 'components/BuyerzoneLogo/BuyerzoneLight'
import BbbLogo from 'components/BbbLogo'

// styled components
const StyledLink = styled.a`
	color: ${COLORS.BLACK_TEXT};
	text-decoration: none;

	&:hover {
		cursor: pointer;
		text-decoration: underline;
	}
`

const Separator = styled.span`
	margin: 0 10px;
`

const FooterContainer = styled.div`
	align-items: center;
	display: flex;
	flex-wrap: nowrap;
	height: 50px;
	max-width: 1200px;
	justify-content: center;
	margin: 0 auto;
`

const FooterWrap = styled.footer`
	align-items: center;
	background: ${COLORS.GRAY_FOOTER};
	color: ${COLORS.BLACK_TEXT};
	display: flex;
	height: 525px;
	padding: 30px 0;
`

const FooterSubWrap = styled.div`
	width: 100%;
`

const FooterLogoContainer = styled.div`
	display: flex;
	justify-content: center;
`

const CopyrightWrap = styled.div`
	text-align: center;
`

const BbbLogoContainer = styled.div`
	display: flex;
	justify-content: center;
`

const Footer = ({ logoHeight, logoWidth }) => (
	<FooterWrap>
		<FooterSubWrap>
			<BbbLogoContainer>
				<BbbLogo logoWidth="100px" />
			</BbbLogoContainer>
			<FooterLogoContainer>
				<BuyerzoneLight height={logoHeight} width={logoWidth} />
			</FooterLogoContainer>
			<FooterContainer>
				<StyledLink
					href="https://www.buyerzone.com/about-us/disclaimer/"
					rel="nofollow noopener"
					target="_blank"
				>
					Terms &amp; Conditions
				</StyledLink>
				<Separator>|</Separator>
				<StyledLink href="https://www.buyerzone.com/about-us/privacy/" rel="nofollow noopener" target="_blank">
					Privacy Policy
				</StyledLink>
			</FooterContainer>
			<CopyrightWrap>©{new Date().getFullYear()} BuyerZone.com. All Rights Reserved.</CopyrightWrap>
		</FooterSubWrap>
	</FooterWrap>
)

Footer.propTypes = {
	logoWidth: string,
	logoHeight: string,
}

export default memo(Footer)
